import React, { useState, useEffect } from "react";
import Address from "./SubTab/Address";
import { useNavigate, useParams } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import AddTransport from "./AddEdit/AddTransport";
import EditTransport from "./AddEdit/EditTransport";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import AddCargoDlts from "./AddEdit/AddCargoDlts";
import { getJobOrderCargoList, getJobOrderCommodityList } from "../../../../../Redux/action/Joborder/JoborderAction";
import EditCargoDlts from "./AddEdit/EditCargoDlts";

const CargoDtlsTab = ({ token, user_id,transmode, transtype }) => {
  const { b64id } = useParams();
  const dispatch = useDispatch();
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;
  const navigate = useNavigate();

  const [showLoader, setShowLoader] = useState(false);


  useEffect(() => {
    if (token && user_id) {
      dispatch(getJobOrderCommodityList(token, user_id));
      if (b64id) {
        let id = atob(b64id);
        if (id) {
          dispatch(getJobOrderCargoList(token, user_id, id));
        }
      } else {
        toast.error("Invalid Order ID.");
        navigate(-1);
      }
    } else {
      toast.error("Please login to continue.");
      navigate(`/login?burl=${encodeURIComponent(q)}`);
    }
  }, [token, user_id]);


  const refreshCargoDtls = () => {
    if (token && user_id && b64id) {
      let id = atob(b64id);
      if (id) {
        dispatch(getJobOrderCargoList(token, user_id, id));
      }
    }
  }

  const {
    loadingJobOrderCargoList,
    JobOrderCargoList,
    JobOrderCargoListError,


    loadingJobOrderCommodityList,
    JobOrderCommodityList,
    JobOrderCommodityListError,

  } = useSelector((state) => state?.JoborderReducer);
  //   console.log(JobOrderCargoList);


  const [cargoList, setCargoList] = useState([]);
  useEffect(() => {
    if (loadingJobOrderCargoList) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }

    // console.log("JobOrderCargoList", JobOrderCargoList);
    if (JobOrderCargoList) {
      setCargoList(JobOrderCargoList);
    }
  }, [loadingJobOrderCargoList, JobOrderCargoList])


  const customerOptions = [
    { value: 1, label: "Rohit" },
    { value: 2, label: "Ravi" },
    { value: 3, label: "Sakshi" },
    { value: 4, label: "Abhishek" },
    { value: 5, label: "Shweta" },
  ];
  const organisationOptions = [
    { value: 1, label: "Organisation 1" },
    { value: 2, label: "Orgnaistaion 2" },
    { value: 3, label: "Orgnaistaion 3" },
    { value: 4, label: "Orgnaistaion 5" },
    { value: 5, label: "Orgnaistaion 4" },
  ];

  const [showAdd, setShowAdd] = useState(false);
  const handleCloseAdd = () => setShowAdd(false);
  const handleShowAdd = () => setShowAdd(true);


  const [cargoDtls_id, setCargoDtls_id] = useState(0);

  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);

  const handleShowEdit = (id) => {
    if (token && user_id && b64id && id) {
      setCargoDtls_id(id);
      setShowEdit(true)
    }
  };



  return (
    <>
      <div className="row border-bottom-2 pb-3">
        <div className="col-md-12">
          <div className="card px-3 py-2">
            <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
              <div className="d-flex align-items-center flex-wrap row-gap-2"></div>
              <div className="d-flex align-items-center flex-wrap row-gap-2">
                <a className="btn btn-light me-2">Clear</a>
                <div
                  className="btn btn-primary cursor-pointer me-2"
                  onClick={handleShowAdd}
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Cargo Dtls
                </div>
              </div>
            </div>

            <div className="row">
              <div className="table-responsive">
                <table className="table table-striped table-sm">
                  <thead>
                    <tr>
                      <th scope="col">S. No.</th>
                      <th scope="col">Description</th>
                      <th scope="col">Packages</th>
                      <th scope="col">Inner Packages</th>
                      <th scope="col">Gross Wt</th>
                      <th scope="col">Net Wt</th>
                      <th scope="col">Volume</th>
                      <th scope="col">Charge Wt.</th>
                      <th scope="col">Dimension</th>
                      <th scope="col">Commodity</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cargoList?.map((val, index) => {
                      return <tr>
                        <td>{index + 1}</td>
                        <td>{val?.description}</td>
                        <td>{val?.packages_count} {val?.packages_type}</td>
                        <td>{val?.inner_pkgs_count} {val?.inner_pkgs_type}</td>
                        <td>{val?.gross_weight} {val?.gross_weight_type}</td>
                        <td>{val?.net_weight} {val?.net_weight_type}</td>
                        <td>{val?.volume_weight} {val?.volume_type}</td>
                        <td>{val?.chargeable_wt}</td>
                        <td>{val?.dimension_length ?? 0} x {val?.dimension_width ?? 0} x {val?.dimension_height} {val?.dimension_type} </td>
                        <td>{val?.commodity_detail ? val.commodity_detail.name : ""} ({val?.commodity_type})</td>
                        <td>
                          <div className="dropdown table-action">
                            <a className="action-icon" data-bs-toggle="dropdown" href="#">
                              <i className="fa fa-ellipsis-v"></i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-right">
                              <div className="dropdown-item cursor-pointer" onClick={() => handleShowEdit(val.id)}>
                                <i className="ti ti-edit text-blue me-2"></i> Edit
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    }
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddCargoDlts
        showAdd={showAdd}
        handleCloseAdd={handleCloseAdd}
        token={token}
        user_id={user_id}
        b64id={b64id}
        loadingJobOrderCommodityList={loadingJobOrderCommodityList}
        JobOrderCommodityList={JobOrderCommodityList}
        refreshCargoDtls={refreshCargoDtls}
         transmode={transmode}
          transtype={transtype}
      />

      <EditCargoDlts
        showAdd={showEdit}
        handleCloseAdd={handleCloseEdit}
        token={token}
        user_id={user_id}
        b64id={b64id}
        loadingJobOrderCommodityList={loadingJobOrderCommodityList}
        JobOrderCommodityList={JobOrderCommodityList}
        refreshCargoDtls={refreshCargoDtls}
        cargoDtls_id={cargoDtls_id}
        transmode={transmode}
        transtype={transtype}
      />
    </>
  );
};

export default CargoDtlsTab;
